"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const iterator_to_map_1 = require("./helper/iterator-to-map");
const output_buffering_1 = require("./output-buffering");
class TwingTemplateWrapper {
    /**
     * This method is for internal use only and should never be called
     * directly (use TwingEnvironment::load() instead).
     *
     * @internal
     */
    constructor(env, template) {
        this.env = env;
        this.template = template;
    }
    /**
     * Renders the template.
     *
     * @param {*} context A hash of parameters to pass to the template
     *
     * @returns {string} The rendered template
     */
    render(context = {}) {
        return this.template.render(context);
    }
    /**
     * Checks if a block is defined.
     *
     * @param {string} name The block name
     * @param {*} context A hash of parameters to pass to the template
     *
     * @returns {boolean}
     */
    hasBlock(name, context = {}) {
        return this.template.hasBlock(name, context);
    }
    /**
     * Returns defined block names in the template.
     *
     * @param {*} context A hash of parameters to pass to the template
     *
     * @returns {Array<string>} An array of defined template block names
     */
    getBlockNames(context = {}) {
        return this.template.getBlockNames(context);
    }
    /**
     * Renders a template block.
     *
     * @param {string} name The block name to render
     * @param {*} context A hash of parameters to pass to the template
     *
     * @returns {string} The rendered block
     */
    renderBlock(name, context = {}) {
        if (!(context instanceof Map)) {
            context = iterator_to_map_1.iteratorToMap(context);
        }
        context = this.env.mergeGlobals(context);
        let level = output_buffering_1.TwingOutputBuffering.obGetLevel();
        output_buffering_1.TwingOutputBuffering.obStart();
        try {
            this.template.displayBlock(name, context);
        }
        catch (e) {
            while (output_buffering_1.TwingOutputBuffering.obGetLevel() > level) {
                output_buffering_1.TwingOutputBuffering.obEndClean();
            }
            throw e;
        }
        return output_buffering_1.TwingOutputBuffering.obGetClean();
    }
    /**
     * Displays a template block.
     *
     * @param {string} name The block name to render
     * @param {*} context A hash of parameters to pass to the template
     */
    displayBlock(name, context = {}) {
        if (!(context instanceof Map)) {
            context = iterator_to_map_1.iteratorToMap(context);
        }
        return this.template.displayBlock(name, this.env.mergeGlobals(context));
    }
    /**
     *
     * @returns {TwingSource}
     */
    getSourceContext() {
        return this.template.getSourceContext();
    }
    traceableDisplayBlock(lineno, source) {
        return this.template.traceableMethod(this.displayBlock.bind(this), lineno, source);
    }
    ;
    traceableDisplayParentBlock(lineno, source) {
        return this.template.traceableDisplayParentBlock(lineno, source);
    }
    ;
    traceableRenderBlock(lineno, source) {
        return this.template.traceableMethod(this.renderBlock.bind(this), lineno, source);
    }
    traceableRenderParentBlock(lineno, source) {
        return this.template.traceableRenderParentBlock(lineno, source);
    }
    traceableHasBlock(lineno, source) {
        return this.template.traceableHasBlock(lineno, source);
    }
}
exports.TwingTemplateWrapper = TwingTemplateWrapper;
